import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../utils/api';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [complete, setComplete] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    if (!token) return setError('This reset link is invalid.');
    if (password.length < 8) return setError('Password must be at least 8 characters.');
    if (password !== confirm) return setError('Passwords do not match.');

    setSaving(true);
    try {
      await api.post('/auth/reset-password', { token, newPassword: password });
      setComplete(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not reset the password. Please request a new link.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0B1F2E', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 400, background: '#fff', borderRadius: 14, padding: 30, boxShadow: '0 10px 40px rgba(0,0,0,0.25)' }}>
        <img src="/mcg-logo.png" alt="MCG Career College" style={{ maxWidth: 190, maxHeight: 55, objectFit: 'contain', marginBottom: 20 }} />
        {complete ? (
          <>
            <h1 style={{ margin: '0 0 8px', fontSize: 22, color: '#111' }}>Password updated</h1>
            <p style={{ color: '#6b7280', lineHeight: 1.5, fontSize: 14 }}>Your password has been changed. You can now sign in.</p>
            <Link to="/login" style={{ display: 'block', textAlign: 'center', padding: 11, marginTop: 20, borderRadius: 8, background: '#0B1F2E', color: '#fff', textDecoration: 'none', fontWeight: 600 }}>
              Return to sign in
            </Link>
          </>
        ) : (
          <>
            <h1 style={{ margin: '0 0 8px', fontSize: 22, color: '#111' }}>Choose a new password</h1>
            <p style={{ color: '#6b7280', lineHeight: 1.5, fontSize: 14, marginBottom: 22 }}>This reset link expires after 30 minutes and can only be used once.</p>
            <form onSubmit={submit}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>New password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" autoFocus
                style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, marginBottom: 14 }} />
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>Confirm password</label>
              <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password"
                style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14 }} />
              <div style={{ color: '#9ca3af', fontSize: 12, margin: '7px 0 14px' }}>At least 8 characters.</div>
              {error && <div style={{ color: '#b91c1c', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: 10, fontSize: 13, marginBottom: 14 }}>{error}</div>}
              <button type="submit" disabled={saving} style={{ width: '100%', border: 0, borderRadius: 8, padding: 11, background: saving ? '#9ca3af' : '#0B1F2E', color: '#fff', fontWeight: 600, cursor: saving ? 'default' : 'pointer' }}>
                {saving ? 'Updating…' : 'Update password'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}